"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HemisphereUtils = void 0;
const Hemisphere_1 = require("./Hemisphere");
/**
 * Helper functions for Hemisphere
 *
 * @since 1.0.0
 */
class HemisphereUtils {
    /**
     * Get the hemisphere for the latitude
     *
     * @param latitude
     *            latitude
     * @return hemisphere
     */
    static fromLatitude(latitude) {
        return latitude >= 0 ? Hemisphere_1.Hemisphere.NORTH : Hemisphere_1.Hemisphere.SOUTH;
    }
    /**
     * Get the hemisphere for the point
     *
     * @param point
     *            point
     * @return hemisphere
     */
    static from(point) {
        return HemisphereUtils.fromLatitude(point.getLatitude());
    }
}
exports.HemisphereUtils = HemisphereUtils;
//# sourceMappingURL=HemisphereUtils.js.map